export default {
    props: {
        filterableExtra: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.extra'
        }, 
        filterableMessagesAnd: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.and'
        }, 
        filterableMessagesClear: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.clear'
        }, 
        filterableMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.filter'
        }, 
        filterableMessagesInfo: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.info'
        }, 
        filterableMessagesTitle: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.title'
        }, 
        filterableMessagesIsFalse: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isFalse'
        }, 
        filterableMessagesIsTrue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isTrue'
        }, 
        filterableMessagesOr: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.or'
        }, 
        filterableMessagesSelectValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectValue'
        }, 
        filterableMessagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.cancel'
        }, 
        filterableMessagesOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.operator'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Filterable.js